<template>
  <div class="anchor-page-container">
    <!-- 左侧导航菜单 -->
    <div class="left-menu">
      <ul>
        <li
          v-for="(item, index) in menuList"
          :key="index"
          :class="{ active: activeIndex === index }"
          @click="scrollToAnchor(item.id)"
        >
          {{ item.title }}
        </li>
      </ul>
    </div>

    <!-- 右侧文章内容区域 -->

    <div class="right-content" ref="contentWrapper">
      <div class="right-content-banner">
        <img src="../assets/image/artiBanner.jpg" />
      </div>
      <div class="ai_report_data" v-html="articleBody" v-if="articleBody !== null"></div>
       <div  v-else>
        <div class="ai_report_data_no" >AI报告内容生成中....</div>
       <div class="ai_report_button"><van-button type="info" :loading ="loadingA"  size="large" @click="handleReload">刷新</van-button></div>
      </div>
    </div>
  </div>
</template>

<script>
import Report from "../models/Report";
export default {
  name: "ArticleAnchor",
  props: ["list"],
  data() {
    return {
      menuList: [
        { id: "chapter1", title: "核心解读" },
        { id: "chapter2", title: "具体运动发展机会" },
        { id: "chapter3", title: "科学运动行动指南" },
        { id: "chapter4", title: "运动健康动态监测" },
        { id: "chapter5", title: "家长/教练特别提示" },
      ],
      activeIndex: 0,
      scrollTimer: null,
      articleBody:'',
      loadingA:false,
        
    };
  },
 
  mounted() {
    this.articleBody = this.list;

    // ===== 修复关键点 1：等 v-html 渲染完成 =====
    this.$nextTick(() => {
      this.$refs.contentWrapper.addEventListener("scroll", this.handleScroll);
      // 刚进来就刷新一次位置
      this.handleScroll();
    });
  },
  beforeDestroy() {
    this.$refs.contentWrapper.removeEventListener("scroll", this.handleScroll);
    if (this.scrollTimer) clearTimeout(this.scrollTimer);
  },
  methods: {
     handleReload(){
      this.loadingA = true;
     let params = {
      user_no: this.$route.query.user_no,
      test_report_id: this.$route.query.id,
    };
    Report.getReports({ ...params }, (res, err) => {
      this.loading = true;
      if (!err) {
        this.articleBody = res.ai_report_data
        this.loadingA = false
      } else {
        console.log(err);
        this.loadingA = false
        Notify({ type: "warning", message: err.message });
      }
    });
    },
    // 点击跳转（修复版）
    scrollToAnchor(id) {
      this.$nextTick(() => {
        const el = document.getElementById(id);
        const wrapper = this.$refs.contentWrapper;
        if (el && wrapper) {
          wrapper.scrollTo({
            top: el.offsetTop - 30,
            behavior: "smooth",
          });
        }
      });
    },

    // 滚动联动（修复版）
    handleScroll() {
      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        const wrapper = this.$refs.contentWrapper;
        const scrollTop = wrapper.scrollTop;

        let currentIndex = 0;

        // ===== 修复关键点 2：倒序遍历，找到最靠近顶部的章节 =====
        for (let i = this.menuList.length - 1; i >= 0; i--) {
          const item = this.menuList[i];
          const el = document.getElementById(item.id);
          if (!el) continue;

          const top = el.offsetTop - 50;
          if (scrollTop >= top) {
            currentIndex = i;
            break;
          }
        }

        this.activeIndex = currentIndex;
      }, 30);
    },
  },
};
</script>

<style scoped>
.anchor-page-container {
  display: flex;
  width: 100%;
  height: 92vh;
  overflow: hidden !important;
  border: 1px solid #eee;
  border-radius: 8px;
  position: relative;
}
.ai_report_data_no{
  text-align: center;
  padding-top: 40px;
  font-size: 32px;
}
.ai_report_button{
  text-align:center;
  margin-top:20px;
}
.ai_report_button .van-button{
  font-size:30px
}
.left-menu {
  width: 150px;
  background: #f8f9fa;
  border-right: 1px solid #eee;
  height: 100%;
}

.left-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.left-menu li {
  padding: 22px 20px;
  cursor: pointer;
  font-size: 24px;
  color: #333;
}

.left-menu li.active {
  background: #2e94e5;
  color: white;
  font-weight: bold;
}

.right-content {
  flex: 1;
  padding: 30px 30px 60px 30px;
  overflow-y: auto;
  background: #fff;
}
.right-content-banner {
  margin-bottom: 40px;
}
.right-content-banner img {
  width: 100%;
  height: auto;
}
</style>